export interface IReportOption {
  id: ReportId;
  name: string;
  description: string;
  usesComparison: boolean;
  multiAthlete: boolean;
}

export type ReportId =
  | 'trend'
  | 'profile'
  | 'comparison'
  | 'ratio'
  | 'asymmetry'
  | 'dsi'
  | 'eur'
  | 'block'
  | 'weight'
  | 'quadrant'
  | 'tsa';

/**
 * @description available report options
 */
export const reportOptions: IReportOption[] = [
  {
    id: 'trend',
    name: 'Trend Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'profile',
    name: 'Profile Report',
    description: '',
    usesComparison: true,
    multiAthlete: false,
  },
  {
    id: 'comparison',
    name: 'Comparison Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'ratio',
    name: 'Ratio Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'asymmetry',
    name: 'Asymmetry Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'dsi',
    name: 'DSI Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'eur',
    name: 'EUR Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'block',
    name: 'Block Report',
    description: '',
    usesComparison: true,
    multiAthlete: false,
  },
  {
    id: 'weight',
    name: 'Weight Report',
    description: '',
    usesComparison: false,
    multiAthlete: false,
  },
  {
    id: 'quadrant',
    name: 'Quadrant Report',
    description: '',
    usesComparison: true,
    multiAthlete: false,
  },
  {
    id: 'tsa',
    name: 'TSA Report',
    description: '',
    usesComparison: true,
    multiAthlete: false,
  },
];
